/**
 * Central place to configure LivePass consumer API endpoint paths.
 *
 * These are joined onto `ApiConfigService.BASE_URL` via `apiConfig.getUrl(path)`.
 * Adjust the paths here to match your backend routes without touching feature code.
 */
export const livepassEndpoints = {
  /** OTP send for login/registration */
  otpSend: 'auth/send-otp',

  /** OTP verify for login/registration (returns tokens) */
  otpVerify: 'auth/verify-otp',

  /** Create Razorpay order for checkout */
  createOrder: 'orders/create',

  /** Verify/complete payment after Razorpay success */
  verifyPayment: 'payments/verify',

  /** Hold selected seats after chart selection */
  holdSeats: 'cart/hold-seats',

  /** Release held seats after hold expires / booking abandoned */
  releaseSeats: 'seatsio/release-seats',
};

